import { Link } from 'react-router-dom';

export function Breadcrumb({ items }) {
  return (
    <nav className="flex items-center text-sm">
      {items.map((item, index) => (
        <div key={item.href} className="flex items-center">
          {index > 0 && (
            <img src="/images/icons/chevron-left-gray.svg" className="mx-2 h-2 w-2 text-gray-400" />
          )}
          <Link
            to={item.href}
            className={`text-sm font-medium leading-[1.5] text-gray-500 transition-colors hover:text-gray-600 `}
          >
            {item.label}
          </Link>
        </div>
      ))}
    </nav>
  );
}
